import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dae749e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Paths in progress", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "All paths", -1))
const _hoisted_7 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course_card = _resolveComponent("course-card")!
  const _component_search_bar = _resolveComponent("search-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.started_courses.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Select the path below to get started "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.started_courses, (course) => {
        return (_openBlock(), _createBlock(_component_course_card, {
          key: course.id,
          title: course.title,
          info: course.info,
          stack: course.stack,
          button_text: course.button_text,
          img: course.img,
          to: _ctx.generateLink(course.id)
        }, null, 8, ["title", "info", "stack", "button_text", "img", "to"]))
      }), 128))
    ]),
    _hoisted_5,
    _hoisted_6,
    _createVNode(_component_search_bar, { placholder_text: "Search for all paths" }),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
        return (_openBlock(), _createBlock(_component_course_card, {
          key: course.id,
          title: course.title,
          info: course.info,
          stack: course.stack,
          button_text: course.button_text,
          img: course.img,
          to: _ctx.generateLink(course.id)
        }, null, 8, ["title", "info", "stack", "button_text", "img", "to"]))
      }), 128))
    ])
  ]))
}